import React, {Component} from 'react';
import {Modal, Checkbox, message} from "antd";

class ChooseUserModal extends Component {

    state = {
        visible : false,
        users : []
    };

    checkedUserAccount = [];

    onChange = (value) =>{
        this.checkedUserAccount = value;
    };

    okCallBack = () =>{};

    showModal = (data, okCallBack) => {
        this.setState({
            visible: true,
            users : data
        });
        this.okCallBack = okCallBack;
    };

    handleOk = () => {
        if (this.checkedUserAccount.length > 0) {
            this.okCallBack(this.checkedUserAccount);
            this.setState({
                visible: false
            });
        } else {
            message.error("请选择编辑");
        }
    };

    handleCancel = () => {
        this.setState({
            visible : false
        })
		this.props.onCancel();
    };

    render() {
        let plainOptions = [];
        this.state.users.map(item => {
            plainOptions.push({label:item.first,value:item.id});
        });
        return (
            <Modal
                title="选择审核人"
                visible={this.state.visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel.bind(this)}
            >
                <Checkbox.Group options={plainOptions} onChange={this.onChange} />
            </Modal>
        );
    }
}

export default ChooseUserModal;
ChooseUserModal.defaultProps = {
	onCancel: ()=>{}
}